import React from 'react';
import { View, Platform } from 'react-native';
import { TextInput, Text } from 'react-native-paper';
import { getLocales } from 'expo-localization';

export default function TwinNumberTextInput (props) {
  const [dataOne, setDataOne] = React.useState('');
  const [dataTwo, setDataTwo] = React.useState('');
  const [valueOne, setValueOne] = React.useState('');
  const [valueTwo, setValueTwo] = React.useState('');
  const deviceLanguage = getLocales()[0].languageCode;  

  React.useEffect(() => {
    let text = props.defaultValue || props.value;
    if(text) {
      onChangeTextInputOne(text['from'] ? text['from'].toString().replace(",", '') : '');
      onChangeTextInputTwo(text['to'] ? text['to'].toString().replace(",", '') : '');
    }
  }, []);

  const numberWithComma = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const onChangeTextInputOne = (text) => {
    const numericRegex = /^([0-9])+$/
    if(text == '') {
      setValueOne(text);
      setDataOne(text)
    } else {
      if(numericRegex.test(text)) {
        setValueOne(text);
        setDataOne(text)
      }
    }
    props.myOnChangeText({...props.value, ...{from: text}});
  }

  const onChangeTextInputTwo = (text) => {
    const numericRegex = /^([0-9])+$/
    if(text == '') {
      setValueTwo(text);
      setDataTwo(text)
    } else {
      if(numericRegex.test(text)) {
        setValueTwo(text);
        setDataTwo(text)
      }
    }
    props.myOnChangeText({...props.value, ...{to: text}});
  }

  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
      <Text style={{ width: '100%', fontSize: 14, color: '#292D32', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{props.label}</Text>
      <View style={{ width: '49%' }}>
        <TextInput 
          {...props}
          label="حداقل"
          placeholder=""
          onChange={(data) => onChangeTextInputOne(data.nativeEvent.text)}
          value={valueOne}
        />
        {
          props.format !== false && <Text style={{ position: 'absolute', top: '20%', left: 6, fontSize: 12, color: '#555' }}>{numberWithComma(dataOne)}</Text>
        }
      </View>
      <View style={{ width: '49%' }}>
        <TextInput 
          {...props}
          label="حداکثر"
          placeholder=""
          onChange={(data) => onChangeTextInputTwo(data.nativeEvent.text)}

          value={valueTwo}
        />
        {
          props.format !== false && <Text style={{ position: 'absolute', top: '20%', left: 6, fontSize: 12, color: '#555' }}>{numberWithComma(dataTwo)}</Text>
        }
      </View>
    </View>
  );
}